import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskRovoServiceAgentRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-rovo-service-agent',
	path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent',
	exact: true,
};
